import styled, { css } from 'styled-components';

export const AccordionContainer = styled.div`
  height: ${({ theme }) => theme.height.h6};
  padding: ${({ theme }) => `0 ${theme.spacing.m}`};
  display: flex;
  align-content: center;
  flex-wrap: wrap;
  justify-content: space-between;
  cursor: pointer;
`;

export const AccordionContent = styled.div(
  ({ theme, height }) => css`
    background-color: ${theme.colors.seasalt};
    max-height: ${height};
    padding: 0 ${theme.spacing.m};
    overflow: hidden;
    transition: max-height 0.6s ease;
  `
);

export const AccordionTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSize.m};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.eerieBlack};
`;
